// extracted by mini-css-extract-plugin
export var explainable = "_jj-a";
export var printerCard = "_jj-1";
export var printerCardConfigured = "_jj-2";
export var printerCardError = "_jj-3";
export var printerCardsContainer = "_jj-0";
export var printerIcon = "_jj-8";
export var printerIconConfigured = "_jj-5";
export var printerIconContainer = "_jj-4";
export var printerIconError = "_jj-6";
export var printerIconUnconfigured = "_jj-7";
export var workstationsTableCard = "_jj-9";